import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography} from "@mui/material";
import {ThreeDots} from 'react-loader-spinner';
import {useEffect} from "react";
import useProjects from "../../../hooks/useProjects";

const RestoreProjectDialog = (props) => {

    const {openRestoreProject, handleClose, project, setIsRestored} = props;

    const {restoreDeletedProject, restoringDeletedProject, restored} = useProjects();

    const handleRestoreProject = (id) => {
        restoreDeletedProject(id)
    }

    useEffect(() => {
        if (restored){
            setIsRestored(true)
            handleClose();
        }
    }, [restored])


    return(
        <Dialog open={openRestoreProject} onClose={handleClose} maxWidth={'sm'} fullWidth={'sm'} PaperProps={{style: {boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px', borderRadius: 5}}}>
            <DialogTitle>
                Restore Project Confirmation
            </DialogTitle>

            <Divider />

            <DialogContent sx={{padding: 6, paddingTop: 2}}>
                <Typography sx={{fontSize: 16}}>
                    Are you sure you want to restore <strong>{project?.application_name}</strong>?
                </Typography>
            </DialogContent>

            <DialogActions sx={{padding: 6, paddingTop: 0, paddingBottom: 3}}>
                <Button sx={{color: "black", textTransform: "none", fontSize: 14}} onClick={handleClose}>
                    Cancel
                </Button>

                <Button variant="contained" sx={{backgroundColor: "#0178f2", borderRadius: 1, textTransform: "none", fontSize: 14, '&:hover': {backgroundColor: "#0178f2", color: "white"}}}
                    onClick={() => handleRestoreProject(project?.id)} 
                    startIcon={restoringDeletedProject && <ThreeDots height="20" width="20" radius="9" color="#ffff" ariaLabel="three-dots-loading" visible={true} />}
                >
                    {restoringDeletedProject ? "Restoring" : "Restore"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default RestoreProjectDialog